<template>
    <!-- <div class="container boxWithBorder"> -->
      <div class="my-5">
        <h1 class="is-size-4">When booking travel</h1>
     <b-field class="mt-5" label="What level of approval do you want when a traveler books an option that violates a rule?"></b-field>
    <b-field>
        <b-radio
          :value="approvalLevelObj.approvalLevel"
          native-value="hard"
          @input="emitApprovalLevel"
        >
        <b-field label ="An approver must approve the trip">
            Automatically denied at the approval deadline if no action is taken
        </b-field>
        </b-radio></b-field>
        <b-field>
        <b-radio
          :value="approvalLevelObj.approvalLevel"
          native-value="soft"
          @input="emitApprovalLevel"
        >
         <b-field label ="An approver can review  the trip">
            Automatically approved at the approval deadline if no action is taken
         </b-field>
        </b-radio></b-field>
      <b-field>
        <b-radio
          :value="approvalLevelObj.approvalLevel"
          native-value="none"
          @input="emitApprovalLevel"
        >
          <b-field label ="No approval process"> 
            If you only want to be notified of the trip
          </b-field>
        </b-radio>
      </b-field>
    </div>
   </template>
   <script>
   
       export default {
         name: "ApprovalLevel",
         props: {
   
    approvalLevel:String
  },
         components: {},
         data() {
           return {
            approvalLevelObj:{
              approvalLevel: this.approvalLevel ,
            }
           }
         },
         methods:{
          emitApprovalLevel (val) {
            this.approvalLevelObj.approvalLevel = val;
            this.$emit('emitData', this.approvalLevelObj);
        }
         },
         mounted() {
          this.$emit('emitData', this.approvalLevelObj);
         },
         watch: {
    
    approvalLevel: {
      handler(newVal, prevVal) {

      this.approvalLevelObj.approvalLevel=newVal;
     
      },
      deep: false,
    }
      
}
       }
     </script>
   
     <style scoped>
     </style>